/**
 * A local address of the app (`powrot=` of the picking modes and of „Dodaj w katalogu dostawcy”): one „/” first, never
 * „//” nor „\” (another host for the browser), no control characters (review I1: the URL parser drops a tab or a new
 * line, so `/\t/evil.com` would be `//evil.com`), and — the last word — resolved, it stays on this origin.
 */
const BASE = 'https://x.invalid';

export function isLocalPath(p: string): boolean {
  if (!p.startsWith('/') || p.startsWith('//') || /[\u0000-\u001F\u007F\\]/.test(p)) return false;
  try {
    return new URL(p, BASE).origin === BASE;
  } catch {
    return false;
  }
}
